<template>
  <div class="search-heroes-by-name">
    <el-form
      class="search-heroes__form card"
      :rules="searchFormRules"
      :model="searchForm"
      label-position="top"
      ref="searchForm"
      @submit.native.prevent="validate"
    >
      <el-form-item label="Name" prop="name" :error="searchFormErrors.name">
        <el-input v-model="searchForm.name" />
      </el-form-item>
    </el-form>
    <div class="search-heroes__buttons">
      <el-button type="primary" @click="validate" :disabled="isButtonDisabled('search-users')">
        Search
      </el-button>
    </div>
  </div>
</template>

<script>
import { parseErrorsByFields } from '@/utils/index.js';
import { searchTeammates } from '@/api/team.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'SearchByName',
  props: {
    skip: {
      type: Number,
      required: false,
    },
    limit: {
      type: Number,
      required: false,
    },
    teamId: {
      type: Number,
      required: false,
    },
  },
  mixins: [disableButton],
  data() {
    return {
      searchForm: { name: null },
      searchFormRules: {
        name: [
          {
            required: true,
            trigger: 'input',
            message: 'Please enter name',
          },
        ],
      },
      searchFormErrors: { name: null },
    };
  },
  computed: {
    formData() {
      const { skip, limit, teamId } = this;
      const { name } = this.searchForm;

      return {
        skip,
        limit,
        filterModel: {
          userName: name,
          teamId,
        },
      };
    },
  },
  methods: {
    parseErrorsByFields,
    async requestSearchTeammates() {
      this.disableButton('search-users');

      const { formData } = this;
      const { errors, success, data } = await searchTeammates(formData);
      this.enableButton('search-users');

      if (success) {
        this.$emit('recieve-data', data);
      } else if (errors) {
        this.searchFormErrors = {
          ...this.searchFormErrors,
          ...this.parseErrorsByFields(errors),
        };
      }
    },
    validate() {
      const { name } = this.searchForm;

      if (name && name.trim()) {
        this.requestSearchTeammates();
      }

      if (this.$refs.searchForm) {
        this.$refs.searchForm.validate();
      }
    },
  },
};
</script>

<style lang="scss">
.search-heroes-by-name {
  margin-bottom: var(--global-dimension-size-250);
}
</style>
